import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Types } from 'src/app/constants/gift-card-type';

@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.page.html',
  styleUrls: ['./gift-cards.page.scss'],
})
export class GiftCardsPage implements OnInit, OnDestroy {
  public title = '';
  public txtBtn = '';
  private _routeObs = new Subscription();
  private _isCoupon = undefined;

  constructor(
    private _route: ActivatedRoute,
    private _trSv: TranslateService,
    private _navCtrl: NavController
  ) {
    this._routeObs.add(
      this._route.queryParamMap.subscribe((params) => {
        this._isCoupon = params.get('coupon');
        this.setTitle();
      })
    );
  }

  ngOnInit() {}

  setTitle() {
    this.title = this._isCoupon ? 'MIS_CUPONES' : 'MIS_GIFTCARDS';
    this.txtBtn = this._trSv.instant('COMPRAR_GIFTCARD', {
      type: this._isCoupon ? this._trSv.instant('CUPONES') : 'Gift card',
    });
  }

  async goToBuyPage() {
    await this._navCtrl.navigateForward('buy-gift-cards', {
      queryParams: {
        isCoupon: this._isCoupon ?? Types.GIFT_CARD,
      },
    });
  }

  ngOnDestroy(): void {
    this._routeObs.unsubscribe();
  }
}
